import SidebarCssVariable from "./SidebarCssVariable";
import tinycolor from "tinycolor2";
import type { CustumizationUserInfo } from "@/types/LoginInfo";

// check sidebar.less
// ex: variableName = " --home-sidebar-bg-color"
// value = "green"
export const setCSSVariable = (variableName: string, value: string): void => {
  document.documentElement.style.setProperty(variableName, value);
};

export const getContrastColor = (colorValue: string): string | undefined => {
  const color = tinycolor(colorValue);
  if (color.isDark()) {
    const lighten = color.lighten(10).toString();
    return lighten;
  } else if (color.isLight()) {
    const darken = color.darken(10).toString();
    return darken;
  }
};

// Old default colors that should be treated as "no custom value"
const OLD_HOME_DEFAULTS: Record<string, string> = {
  homeSideBarColor: "#4E5471",
  homeSideBarSectionFontColor: "#FFFFFF",
  homeSideBarFontColor: "#FFFFFF",
  homeSideBarSelectedColor: "#707B96",
  homeFooterBackgroundColor: "#1D283C",
  homeFooterButtonSelectedColor: "#424B59",
};

const isOldDefault = (key: string, value?: string): boolean => {
  if (!value) return true;
  return value.toUpperCase() === OLD_HOME_DEFAULTS[key];
};

export const setSideBarColors = (data?: CustumizationUserInfo): void => {
  // home theme
  setCSSVariable(
    SidebarCssVariable.homeSideBarColor,
    !isOldDefault("homeSideBarColor", data?.homeSideBarColor)
      ? (data?.homeSideBarColor as string)
      : SidebarCssVariable.homeSideBarColorDefault
  );

  setCSSVariable(
    SidebarCssVariable.homeSideBarSectionFontColor,
    !isOldDefault("homeSideBarSectionFontColor", data?.homeSideBarSectionFontColor)
      ? (data?.homeSideBarSectionFontColor as string)
      : SidebarCssVariable.homeSideBarSectionFontColorDefault
  );
  setCSSVariable(
    SidebarCssVariable.homeSideBarFontColor,
    !isOldDefault("homeSideBarFontColor", data?.homeSideBarFontColor)
      ? (data?.homeSideBarFontColor as string)
      : SidebarCssVariable.homeSideBarFontColorDefault
  );

  setCSSVariable(
    SidebarCssVariable.homeSideBarSelectedColor,
    !isOldDefault("homeSideBarSelectedColor", data?.homeSideBarSelectedColor)
      ? (data?.homeSideBarSelectedColor as string)
      : SidebarCssVariable.homeSideBarSelectedColorDefault
  );

  setCSSVariable(
    SidebarCssVariable.homeFooterBackgroundColor,
    !isOldDefault("homeFooterBackgroundColor", data?.homeFooterBackgroundColor)
      ? (data?.homeFooterBackgroundColor as string)
      : SidebarCssVariable.homeFooterBackgroundColorDefault
  );

  setCSSVariable(
    SidebarCssVariable.homeFooterButtonSelectedColor,
    !isOldDefault("homeFooterButtonSelectedColor", data?.homeFooterButtonSelectedColor)
      ? (data?.homeFooterButtonSelectedColor as string)
      : SidebarCssVariable.homeFooterButtonSelectedColorDefault
  );

  // admin theme
  setCSSVariable(
    SidebarCssVariable.adminSideBarColor,
    data?.adminSideBarColor
      ? data?.adminSideBarColor
      : SidebarCssVariable.adminSideBarColorDefault
  );

  setCSSVariable(
    SidebarCssVariable.adminSideBarSectionFontColor,
    data?.adminSideBarSectionFontColor
      ? data?.adminSideBarSectionFontColor
      : SidebarCssVariable.adminSideBarSectionFontColorDefault
  );
  setCSSVariable(
    SidebarCssVariable.adminSideBarFontColor,
    data?.adminSideBarFontColor
      ? data?.adminSideBarFontColor
      : SidebarCssVariable.adminSideBarFontColorDefault
  );

  setCSSVariable(
    SidebarCssVariable.adminSideBarSelectedColor,
    data?.adminSideBarSelectedColor
      ? data?.adminSideBarSelectedColor
      : SidebarCssVariable.adminSideBarSelectedColorDefault
  );

  setCSSVariable(
    SidebarCssVariable.adminFooterBackgroundColor,
    data?.adminFooterBackgroundColor
      ? data?.adminFooterBackgroundColor
      : SidebarCssVariable.adminFooterBackgroundColorDefault
  );

  setCSSVariable(
    SidebarCssVariable.adminFooterButtonSelectedColor,
    data?.adminFooterButtonSelectedColor
      ? data?.adminFooterButtonSelectedColor
      : SidebarCssVariable.adminFooterButtonSelectedColorDefault
  );
};
